export class Atendimento {}
